module.exports = __webpack_public_path__ + "img/rice_01.88fa2ebf.png";